import http from '@/utils/http';

const baseUrl = '/rastreabilidade/lote-producao';

export default {
    pesquisar(filtro) {
        return http.get({
            url: baseUrl + `/buscar?filtro=${filtro}`,
            lockScreen: false
        });
    },

    buscar(filtros, paginacao) {
        let textoBusca = '';
        if (filtros !== '') {
            textoBusca = filtros.textoBusca;
        }
        const { direcao, itensPorPagina, ordernarPor, pagina } = paginacao;
        let url =
            baseUrl + '?texto-busca=' + textoBusca + '&pagina=' + pagina;

        if (direcao !== null && direcao !== undefined) {
            url += '&direcao=' + direcao;
        }

        if (itensPorPagina !== null && itensPorPagina !== undefined) {
            url += '&itens-por-pagina=' + itensPorPagina;
        }

        if (ordernarPor !== null && ordernarPor !== undefined) {
            url += '&ordenar-por=' + ordernarPor;
        }

        return http.get({
            url: url,
            lockScreen: true,
            lockMessage: 'Buscando Lotes de Produção'
        });
    },

    buscarTotalizadoresLoteDeProducao() {
        return http.get({
            url: baseUrl + `/totalizadores`,
            lockScreen: false
        });
    },

    editarLoteDeProducao(payload) {
        return http.post({
            url: baseUrl + '/editar',
            data: payload,
            lockScreen: true
        });
    },

    excluirLoteDeProducao(payload) {
        return http.post({
            url: baseUrl + '/excluir',
            data: payload,
            lockScreen: true
        });
    },

    baixarModeloCsv() {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: baseUrl + `/download-modelo-csv`,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: 'Preparando dados para download'
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;
                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    buscarPorFazenda(codigoFazenda, paginacao) {
        const { direcao, itensPorPagina, ordernarPor, pagina } = paginacao;
        let url =
            baseUrl + '/buscar-por-fazenda' + '?codigo-fazenda=' + codigoFazenda + '&pagina=' + pagina;

        if (direcao !== null && direcao !== undefined) {
            url += '&direcao=' + direcao;
        }

        if (itensPorPagina !== null && itensPorPagina !== undefined) {
            url += '&itens-por-pagina=' + itensPorPagina;
        }

        if (ordernarPor !== null && ordernarPor !== undefined) {
            url += '&ordenar-por=' + ordernarPor;
        }

        return http.get({
            url: url,
            lockScreen: true,
            lockMessage: 'Buscando Lotes de Produção'
        });
    },

    buscarPorNumeroEdata(codigoFazenda, filtros, dataInicio, dataFim, paginacao) {
        let textoBusca = '';
        if (filtros !== '') {
            textoBusca = filtros.textoBusca;
        }
        const { direcao, itensPorPagina, ordernarPor, pagina } = paginacao;
        let url =
            baseUrl +
             '/buscar-por-numero-data' +
              '?codigo-fazenda=' + codigoFazenda +
              '&numero-lote-producao=' + textoBusca +
              '&data-inicio=' + dataInicio +
              '&data-fim=' + dataFim +
               '&pagina=' + pagina;

        if (direcao !== null && direcao !== undefined) {
            url += '&direcao=' + direcao;
        }

        if (itensPorPagina !== null && itensPorPagina !== undefined) {
            url += '&itens-por-pagina=' + itensPorPagina;
        }

        if (ordernarPor !== null && ordernarPor !== undefined) {
            url += '&ordenar-por=' + ordernarPor;
        }

        return http.get({
            url: url,
            lockScreen: true,
            lockMessage: 'Buscando Lotes de Produção'
        });
    }
};
